import { render, staticRenderFns } from "./loginModel.vue?vue&type=template&id=83a5f6d2&scoped=true"
import script from "./loginModel.vue?vue&type=script&lang=js"
export * from "./loginModel.vue?vue&type=script&lang=js"
import style0 from "./loginModel.vue?vue&type=style&index=0&id=83a5f6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a5f6d2",
  null
  
)

export default component.exports